import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Timeline, TimelineFilters, type TimelineFilter } from '../../components/crm/Timeline';
import { Icon } from '../../components/ui/Icon';
import { timelineQuery } from '../../lib/queries';
import styles from './Pages.module.css';

/** The workspace-level Timeline feed — the Echo surface. */
export function ActivityPage() {
  const [filter, setFilter] = useState<TimelineFilter>('all');
  const events = useQuery(
    timelineQuery({ limit: 100, ...(filter === 'all' ? {} : { actorKind: filter }) }),
  );

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>
          <span className={styles.titleIcon}>
            <Icon name="history-toggle" size={20} />
          </span>
          Timeline
        </h1>
      </header>
      <div className={styles.body}>
        <div className={styles.column}>
          <TimelineFilters value={filter} onChange={setFilter} />
          {events.isLoading ? (
            <p className={styles.state}>Loading…</p>
          ) : (
            <Timeline events={events.data?.events ?? []} />
          )}
        </div>
      </div>
    </div>
  );
}
